{
  "manager": {
    "notificationSendPlan": {
      "readyToSend": "Ready to send"
    },
    "notificationCreator": {
      "audienceRequired": "Add at least one Include group so this notification has recipients.",
      "saveDraft": "Save Draft",
      "previewAndSend": "Preview & Send",
      "fieldRequired": "This field is required.",
      "subjectLabel": "Subject *",
      "subjectPlaceholder": "Enter your subject"
    },
    "notificationView": {
      "backToNotifications": "Back to Notifications",
      "viewNotification": "View Notification"
    }
  }
}
